import Vue from "vue";

const baseAppEventBus = new Vue();

export default baseAppEventBus;
